// extracted by mini-css-extract-plugin
export default {"wrapper":"Spoiler_wrapper_ac8e1","title":"Spoiler_title_d74b3","active":"Spoiler_active_f086a","content":"Spoiler_content_cf50b"};